import { StudentAnswerDTO } from '../answer';
import { StatusEnum } from '../status';
import { IStudentAssignmentDTO } from '../student-assignment';

export interface IStudentGradeUnitDayListItemDTO {
  classroomAssignmentId?: number;
  studentAssignments?: IStudentAssignmentDTO[];
  answers?: StudentAnswerDTO[];
  dayId: number;
  dayTitle: string;
  dayNumber: number;
  dayStartPage: string;
  dayEndPage: string;
  unitId: number;
  unitGradeLevel: number;
  dayCoverImageId: string;
  dayCoverImageUrl: string;
  bucket: string;
  key: string;
  fileName: string;
  assignmentStatus: StatusEnum;
  dueDate?: Date;
  isQuiz?: boolean;
}

export class StudentGradeUnitDayListItemDTO
  implements IStudentGradeUnitDayListItemDTO
{
  classroomAssignmentId?: number = null;
  studentAssignments?: IStudentAssignmentDTO[] = [];
  dayId: number = -1;
  dayTitle: string = '';
  dayNumber: number = -1;
  dayStartPage: string = '';
  dayEndPage: string = '';
  unitId: number = -1;
  unitGradeLevel: number = -1;
  dayCoverImageId: string = '';
  dayCoverImageUrl: string = '';
  bucket: string = '';
  key: string = '';
  fileName: string = '';
  assignmentStatus: StatusEnum = StatusEnum.NULL_STATUS;
  isQuiz?: boolean;

  constructor(configOverride?: Partial<IStudentGradeUnitDayListItemDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
